import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

// Lazy load components
const DealsIndex = () => import('./pages/DealsIndex.vue');
const DealShowView = () => import('./pages/DealShowView.vue');
const CRMReportsView = () => import('./pages/CRMReportsView.vue');

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

// Rotas de Deals - lista, detalhe e relatórios
export const routes = [
  {
    path: frontendURL('accounts/:accountId/deals'),
    component: DealsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'deals_list',
        component: DealsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/deals/:dealId'),
    component: DealShowView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'deals_show',
        component: DealShowView,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/crm/reports'),
    component: CRMReportsView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_reports',
        component: CRMReportsView,
        meta: commonMeta,
      },
    ],
  },
];
